import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import useAlertBanner from '#/shared/hooks/useAlertBanner';
import * as Styled from './styled';

function SystemWideAlertSummary({ viewGlobalAlertsClick, systemWideAlert }) {
  const { dismissBanner } = useAlertBanner(systemWideAlert.begin);
  return (
    <Styled.AlertBannerBody type={systemWideAlert.system_wide_message.type}>
      <Styled.IconTitleViewWrapper>
        <Styled.IconTitleWrapper
          type={systemWideAlert.system_wide_message.type}
          onClick={() => {
            viewGlobalAlertsClick();
            dismissBanner();
          }}
        >
          <Styled.AlertIcon type={systemWideAlert.system_wide_message.type} />
          <Styled.AlertHeaderTitle>
            {systemWideAlert.header_text}
          </Styled.AlertHeaderTitle>
        </Styled.IconTitleWrapper>
        <Styled.AlertButton
          type={systemWideAlert.system_wide_message.type}
          onClick={() => {
            viewGlobalAlertsClick();
            dismissBanner();
          }}
        >
          <FormattedMessage id="alerts.view" />
        </Styled.AlertButton>
      </Styled.IconTitleViewWrapper>
      <Styled.CloseButton
        type={systemWideAlert.system_wide_message.type}
        onClick={() => dismissBanner()}
      >
        <Styled.CloseIcon type={systemWideAlert.system_wide_message.type} />
      </Styled.CloseButton>
    </Styled.AlertBannerBody>
  );
}

SystemWideAlertSummary.propTypes = {
  viewGlobalAlertsClick: PropTypes.func,
  /** System Wide Alert to Display in the badge */
  systemWideAlert: PropTypes.shape({
    system_wide_message: PropTypes.shape({ type: PropTypes.string.isRequired })
      .isRequired,
    header_text: PropTypes.string.isRequired,
    begin: PropTypes.number.isRequired,
  }).isRequired,
};

SystemWideAlertSummary.defaultProps = {
  viewGlobalAlertsClick: () => {},
};

export default SystemWideAlertSummary;
